export default "__VITE_ASSET__CUL1e9hi__"